import { Alert } from 'melp-design/components';
import moment from 'moment';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Benefit, useBenefit } from 'store/benefits';
import { isDefined } from 'utils/isDefined';

interface Props {
  benefitId: string;
}

const EXPIRATION_WARNING_DAYS = 15;

const getDaysUntilExpiration = (deactivationDate: Benefit['deactivatedAt']) => {
  const now = moment();

  if (!deactivationDate || now.isAfter(deactivationDate)) {
    return;
  }

  return Math.round(moment(deactivationDate).diff(now, 'days', true));
};

export const BenefitExpirationWarning: FC<Props> = ({ benefitId }) => {
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = useState(true);

  const { data: benefit } = useBenefit(benefitId);

  if (!benefit) return null;

  const daysUntilExpiration = getDaysUntilExpiration(benefit.deactivatedAt);
  const expiresSoon =
    isDefined(daysUntilExpiration) &&
    daysUntilExpiration <= EXPIRATION_WARNING_DAYS;

  return isVisible && expiresSoon ? (
    <Alert severity="warning" onClose={() => setIsVisible(false)}>
      {t('benefits.expiresSoonWarning', { count: daysUntilExpiration })}
    </Alert>
  ) : null;
};
